"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastContractEndDate = void 0;
const getLastContractEndDate = (contracts) => {
    if (!contracts)
        return null;
    if (contracts.length === 0)
        return null;
    const sortedContracts = contracts.sort((a, b) => {
        if (!a.end_date || !b.end_date)
            return 0;
        return new Date(b.end_date).getTime() - new Date(a.end_date).getTime();
    });
    return sortedContracts[0].end_date;
};
exports.getLastContractEndDate = getLastContractEndDate;
